export const UPLOAD_IMAGE_API: string =
  `${process.env.VUE_APP_API}/widget/oss/signForJs?bucket=liuliangphone-pic&path=`;
export const UPLOAD_CERT_API: string =
  `${process.env.VUE_APP_API}/widget/oss/signForJs?bucket=liuliangphone-cert&path=`;
